export const paths = {
  local: 'portaldev.spectroteldevops.com',
  develop: 'portaldev.spectroteldevops.com',
  dev: 'logindev.spectroteldevops.com',
  staging: 'portalstaging.spectroteldevops.com',
  production: 'nic.spectrotel.com',
}

const local = {
  env: 'localhost',
  baseURL: `https://${paths.local}/v2`,
  domain: `${paths.local}`,
}

const production = {
  env: 'production',
  baseURL: `https://${paths.production}/v2`,
  domain: `${paths.production}`,
}

const staging = {
  env: 'staging',
  baseURL: `https://${paths.staging}/v2`,
  domain: `${paths.staging}`,
}
const develop = {
  env: 'development',
  baseURL: `https://${paths.develop}/v2`,
  domain: `${paths.develop}`,
}
const dev = {
  env: 'development',
  baseURL: `https://${paths.dev}/v2`,
  domain: `${paths.dev}`,
}

const authConfigMap: Record<
  string,
  { domain: string; clientId: string; audience: string }
> = {
  'nic.spectrotel.com': {
    domain: 'nic-portal-production.us.auth0.com',
    clientId: 'H7EuF3BZiIJmuuRkrPU6pqjxGOap30H3',
    audience: 'https://nic.spectrotel.com/v2/',
  },
  'portalstaging.spectroteldevops.com': {
    domain: 'nic-portal-production.us.auth0.com',
    clientId: 'H7EuF3BZiIJmuuRkrPU6pqjxGOap30H3',
    audience: 'https://nic.spectrotel.com/v2/',
  },
  'portaldev.spectroteldevops.com': {
    domain: 'dev-ntptdh16omeg5svl.us.auth0.com',
    clientId: 'oDajaExSMvayQ8fR9zGzceMU6Y4rq8U9',
    audience: 'https://digital-experience-portal-api',
  },
  'logindev.spectroteldevops.com': {
    domain: 'dev-ntptdh16omeg5svl.us.auth0.com',
    clientId: 'oDajaExSMvayQ8fR9zGzceMU6Y4rq8U9',
    audience: 'https://digital-experience-portal-api',
  },
  localhost: {
    domain: 'dev-ntptdh16omeg5svl.us.auth0.com',
    clientId: 'oDajaExSMvayQ8fR9zGzceMU6Y4rq8U9',
    audience: 'https://digital-experience-portal-api',
  },
}

const currentHost = window.location.hostname

export function getENVData() {
  if (currentHost.includes(paths.develop)) {
    return develop
  } else if (currentHost.includes(paths.dev)) {
    return dev
  } else if (currentHost.includes(paths.production)) {
    return production
  } else if (currentHost.includes(paths.staging)) {
    return staging
  } else return local
}

export const authConfig =
  authConfigMap[currentHost] || authConfigMap['localhost']
